<template>
  <v-dialog v-model="dialogActive" fullscreen>
    <template v-slot:activator="{ on }">
      <v-badge v-if="section.actions && section.actions.length > 0" :content="section.actions.length" overlap>
        <v-btn v-on="on">Edit To-Do Items</v-btn>
      </v-badge>
      <v-btn v-else v-on="on">Add To-Do Items</v-btn>
      <v-dialog v-model="actionHelpDialog" width="600">
        <template v-slot:activator="{ on: dialogOn }">
          <v-icon v-on="dialogOn" color="info" style="margin-right:.5em;">fas fa-question-circle</v-icon>
        </template>
        <v-card>
          <v-card-title>ToDo Items</v-card-title>
          <v-card-text>These are to-do-list items (i.e. links) that will be available to the student once they complete this section, which can either point to an action built within the orientation system or a separate webpage (like Canvas, Banner, etc). Some items will automatically clear when the student completes them (such as the internal action for pre-registration), but others will remain until the student dismisses them, allowing them to complete or dismiss the to-do-list item in their own timeframe.</v-card-text>
          <v-card-actions>
            <v-btn text @click="actionHelpDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>To-Do Items</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <p style="margin-top:16px">These are to-do-list items that will be added when the student has completed this section.</p>
        <v-row>
          <v-col :cols="6">
            <v-list elevation="4">
              <v-subheader>List of Items</v-subheader>
              <v-list-item v-for="({ title, link }, index) in section.actions" :key="'action-' + index" @click="select(index)">
                <v-list-item-content>
                  <v-list-item-title>{{ title }}</v-list-item-title>
                  <v-list-item-subtitle>{{ link }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-btn color="success" @click="select(-1)">Add Item</v-btn>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col v-if="selectedIndex != null" :cols="6">
            <v-text-field v-model="title" label="Text" outlined />
            <v-select v-model="linkType" :items="linkTypeOptions" label="Link/Action Type" outlined />
            <!-- <v-row>
              <v-col>
                <v-checkbox v-model="isExternalLink" label="Is External Link" style="margin-top:0">
                  <template v-slot:append>
                    <v-dialog v-model="testHelpModal" width="400">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="info">fas fa-question-circle</v-icon>
                      </template>
                      <v-card>
                        <v-card-title>Is External Link</v-card-title>
                        <v-card-text>External links open in a dialog box, where you can add some extra text using the boxes below. This would be the final information someone would need in order to access the link, like login information or how to get their Banner ID. This also gives them an easier way to dismiss the item when they have completed it, since most external links don't talk to the system to update the to-do list automatically.</v-card-text>
                        <v-card-actions>
                          <v-btn text @click="testHelpModal = false">Close</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox v-model="isLanguageTest" label="Is Language Test" style="margin-top:0" />
              </v-col>
              <v-col>
                <v-checkbox v-model="isMathTest" label="Is Math Test" style="margin-top:0" />
              </v-col>
            </v-row> -->
            <v-combobox v-model="link" :items="actionOptions" :label="linkType === 'math' ? 'Standard MPT Link' : 'Link'" outlined>
              <template v-slot:append-outer>
                <v-dialog v-model="linkHelpModal" width="400">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="info">fas fa-question-circle</v-icon>
                  </template>
                  <v-card>
                    <v-card-title>Link</v-card-title>
                    <v-card-text>This link can be set to an external website (in which case clicking on the link will open in a new tab) or it can be an internal action built within the system. These built-in actions are part of the autocomplete, but any web address can be entered. All exernal web addresses must start with http:// or https://.</v-card-text>
                    <v-card-actions>
                      <v-btn text @click="linkHelpModal = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </v-combobox>
            <v-text-field v-if="linkType === 'math'" v-model="link2" label="Advanced MPT Link" outlined />
            <date-picker v-model="date" label="Available Date" clear-button>
              <template v-slot:append-outer>
                <v-dialog v-model="dateHelpModal" width="400">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="info">fas fa-question-circle</v-icon>
                  </template>
                  <v-card>
                    <v-card-title>Available Date</v-card-title>
                    <v-card-text>If this date is set, then it marks when this action will become available. If the date is not set, then the action will be available upon completion of the current section. If the date is set, then if a student completes the current section before this date then the action will not be made available until this date has been reached. If the date is already past this date then the action will be made available immediately.</v-card-text>
                    <v-card-actions>
                      <v-btn text @click="dateHelpModal = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </date-picker>
            <v-select v-model="condition" :items="conditionOptions" label="Show Conditionally" clearable outlined />
            <template v-if="linkType === 'external'">
              <html-editor v-model="dialogText" style="margin-bottom:1em" />
              <v-row>
                <v-col>
                  <v-text-field v-model="linkText" label="Link Text" outlined />
                </v-col>
                <v-col>
                  <v-text-field v-model="dismissText" label="Dismiss Text" hint="Leave blank to hide button" persistent-hint outlined />
                </v-col>
                <v-col>
                  <v-text-field v-model="doneText" label="Done Text" outlined />
                </v-col>
              </v-row>
            </template>
            <v-toolbar elevation="0">
              <v-btn :disabled="selectedIndex in section.actions && title === section.actions[selectedIndex].title && link === section.actions[selectedIndex].link && date === section.actions[selectedIndex].date" @click="save">Save Changes</v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="selectedIndex >= 0" color="error" @click="$emit('remove', selectedIndex)">Remove Item</v-btn>
            </v-toolbar>
          </v-col>
          <v-col v-else>
            <p>Select an item from the list on the left or click the button to add a new item.</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialogActive = false" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'
import paths from '@/router/paths'
export default {
  components: {
    DatePicker: () => import('../forms/inputs/DatePicker'),
    HtmlEditor: () => import('../forms/HTMLEditor')
  },
  props: {
    section: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup (props, { root, emit }) {
    const dialogActive = ref(false)
    const actionHelpDialog = ref(false)

    const title = ref('')
    const link = ref('')
    const linkType = ref('')
    const linkTypeOptions = ref([{ text: 'Language Test', value: 'language' }, { text: 'Math Test', value: 'math' }, { text: 'External Link', value: 'external' }, { text: 'Internal Link', value: 'internal' }])
    const link2 = ref('')
    const date = ref('')
    const condition = ref('')
    const dialogText = ref('')
    const linkText = ref('')
    const dismissText = ref('')
    const doneText = ref('')
    const selectedIndex = ref(null)

    function select (index) {
      if (index >= 0) {
        const rec = props.section.actions[index]
        title.value = rec.title
        link.value = rec.link
        date.value = 'openDate' in rec && rec.openDate != null ? rec.openDate.substr(0, 10) : ''
        if ('condition' in rec && typeof (rec.condition) === 'object') {
          let temp = rec.condition
          if ('itemIndex' in temp && temp.itemIndex >= 0) {
            condition.value = temp.id + '.items.' + temp.itemIndex
          } else {
            condition.value = temp.id
          }
        } else {
          condition.value = ''
        }
        if (rec.isLanguageTest) linkType.value = 'language'
        else if (rec.isExternalLink) linkType.value = 'external'
        else linkType.value = rec.linkType || ''
        dialogText.value = ('dialogText' in rec ? rec.dialogText : '')
        linkText.value = ('linkText' in rec ? rec.linkText : 'Do it Now')
        dismissText.value = ('dismissText' in rec ? rec.dismissText : 'Dismiss')
        doneText.value = ('doneText' in rec ? rec.doneText : 'Done')
        selectedIndex.value = index
      } else {
        title.value = ''
        link.value = ''
        date.value = ''
        condition.value = ''
        linkType.value = ''
        dialogText.value = ''
        linkText.value = ''
        dismissText.value = ''
        doneText.value = ''
        selectedIndex.value = -1
      }
    }

    function save () {
      let obj = { title: title.value, link: link.value, openDate: date.value }
      if (condition.value !== '') {
        const regex = /.items.[0-9]+$/i
        if (regex.test(condition.value)) {
          let temp = condition.value.split('.items.')
          obj.condition = { id: temp[0], itemIndex: parseInt(temp[1]) }
        } else {
          obj.condition = { id: condition.value, itemIndex: 0 }
        }
      }
      obj.linkType = linkType.value
      if (obj.linkType === 'math') {
        obj.link2 = link2.value
      } else if (obj.linkType === 'external') {
        obj.dialogText = dialogText.value
        obj.linkText = linkText.value
        obj.dismissText = dismissText.value
        obj.doneText = doneText.value
      }
      if (selectedIndex.value >= 0) {
        emit('update', { index: selectedIndex.value, obj })
      } else {
        emit('add', obj)
      }
    }

    const actionOptions = computed(() => {
      let arr = []
      for (let i = 0; i < paths.length; i++) {
        if (paths[i].path.substr(0, 8) === '/action/') arr.push(paths[i].path)
      }
      return arr
    })

    const conditionOptions = ref([])
    watch(() => props.section, async () => {
      let arr = []
      const service = root.$feathers.service('orientation/block')
      // Look at each slide, and each column within each slide, and each item within each column, and determine if the slide might contain interactive content (quiz, agreement, popups, timeline)
      for (const { primary, secondary } of props.section.slides) {
        for (const { id, type, name } of primary) {
          // If so, retrieve that content block so we can determine if it does have one or more items that could be used as a condition
          if (type === 'QuizCard') {
            // let data = await service.get(_id)
          } else if (type === 'Agreement') {
            arr.push({ value: id, text: name })
          } else if (type === 'Popups' || type === 'Timeline') {
            let data = await service.get(id)
            if (data.activatable) {
              for (let i = 0; i < data.items.length; i++) {
                if ('actions' in data.items[i] && 'activate' in data.items[i].actions && data.items[i].actions.activate !== '') {
                  arr.push({ value: id + '.items.' + i, text: 'Activated: ' + data.items[i].title })
                }
              }
            }
          }
        }
        for (const { id, type, name } of secondary) {
          // If so, retrieve that content block so we can determine if it does have one or more items that could be used as a condition
          if (type === 'QuizCard') {
            // let data = await service.get(_id)
          } else if (type === 'Agreement') {
            arr.push({ value: id, text: name })
          } else if (type === 'Popups' || type === 'Timeline') {
            let data = await service.get(id)
            if (data.activatable) {
              for (let i = 0; i < data.items.length; i++) {
                if ('actions' in data.items[i] && 'activate' in data.items[i].actions && data.items[i].actions.activate !== '') {
                  arr.push({ value: id + '.items.' + i, text: 'Activated: ' + data.items[i].title })
                }
              }
            }
          }
        }
      }
      conditionOptions.value = arr
    })

    const dateHelpModal = ref(false)
    const linkHelpModal = ref(false)
    const testHelpModal = ref(false)

    return {
      dialogActive,
      actionHelpDialog,
      title,
      link,
      linkType,
      linkTypeOptions,
      link2,
      date,
      condition,
      dialogText,
      linkText,
      dismissText,
      doneText,
      selectedIndex,
      select,
      save,
      actionOptions,
      conditionOptions,
      dateHelpModal,
      linkHelpModal,
      testHelpModal
    }
  }
}
</script>
